<template>
    <div class="flex flex-wrap items-center justify-center flex-col">
        <h5 class="text-lg text-center text-yellow-200 bg-gray-950 rounded-t-lg p-3">
            <span class="text-white text-base leading-snug">{{ question.attributes.choices.top }}</span>
        </h5>

        <textarea class="text-gray-800 mb-4 w-11/12 lg:w-2/3 xl:w-1/2"
            v-model="value"
        />

        <div class="flex my-4">
            <button class="mx-2" @click="answer">
                {{ $t('Submit') }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        question: {},
    },

    data() {
        return {
            value: '',
        }
    },

    methods: {
        answer() {
            this.$emit('answered', this.value);
        }
    },
}
</script>
